module.exports = __webpack_public_path__ + "src/assets/games/11/69.jpg";